import { auditSupport } from '@mi-front/api-clients';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { BcrPreview } from './BcrPreview';
import { Station } from '@app/core/types/stations';

export function BcrUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      auditSupport.MinUploadBcrResultDto,
      { data: auditSupport.BulkUploadBcrFilesMutationRequest }
    >
      station={station}
      accept=".bcr,.BCR,.bcr.txt,.BCR.TXT,text/plain"
      fileType="BCR"
      useUploadMutation={auditSupport.useBulkUploadBcrFiles}
      renderPreview={(data) => <BcrPreview entries={data.entries ?? []} />}
    />
  );
}
